import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import styles from './infraction-level-tag.module.scss'

export function ComplaintInfractionLevelTag ({ level }) {
  const i18n = useTranslation('translation', { keyPrefix: 'common.resources.complaint.values.infraction-level' })
  const text = i18n.t(`${level}.label`)
  const color = i18n.t(`${level}.color`)
  return (
    <div className={styles.tag_wrapper}>
      <Tag color={color}>{text}</Tag>
    </div>
  )
}
